///مدت
export enum DurationKind {
  /// روز
  Day = 1,
  /// کوتاه مدت
  ShortTerm = 2,
  ///بلند مدت
  LongTerm = 3,
}
export enum ChequeStatusKind {
  ///استفاده شده
  IsUsed = 1,
  ///استفاده نشده
  NotUsed = 2,
  ///ابطال شده
  Canceled = 3,
}
export enum TrsStatusKind {
  /// <summary>
  /// ثبت اولیه
  /// </summary>
  Registered = 1,
  /// <summary>
  /// تایید
  /// </summary>
  Confirmed = 2,
  /// <summary>
  /// ثبت حسابداری
  /// </summary>
  AccountRegistered = 3,
  /// <summary>
  /// ابطال
  /// </summary>
  Cancelled = 4,
  /// <summary>
  /// استقراری
  /// </summary>
  Establishment = 5,
}
